var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-monthly-picker',{attrs:{"monthLabels":_vm.months,"dateFormat":_vm.dateFormat,"value":_vm.value},on:{"input":_vm.monthSelected}})}
var staticRenderFns = []

export { render, staticRenderFns }